import { Injectable } from '@angular/core';

import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Injectable()
export class UpdateService {
    constructor(private swUpdate: SwUpdate) {
        console.log('SW Incoming');
        if (!this.swUpdate.isEnabled) {
            console.log('Nope 🙁');
            return;
        }

        console.log('SW Enabled');
        this.swUpdate.versionUpdates
            .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
            .subscribe((event) => {
                console.log(`current`, event.currentVersion, `available`, event.latestVersion);
                console.log('SW Available');
                console.log('New version available. Load New Version?');
                window.location.reload();
            });
      }

      public checkForUpdates(): void {
        console.log("SW check for update.");
        this.swUpdate.versionUpdates
            .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
            .subscribe((event) => {
                console.log(`current`, event.currentVersion, `available`, event.latestVersion);
                window.location.reload();
            });
    }
}